import React from 'react';

const DriverOnboardingSmsReminders = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={244} height={304} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#F5F5F5"
        d="M2 66.4c0-22.78 0-34.17 4.503-42.839A40 40 0 0 1 23.561 6.503C32.231 2 43.621 2 66.4 2h111.2c22.78 0 34.169 0 42.839 4.503a40 40 0 0 1 17.058 17.058C242 32.231 242 43.621 242 66.4V302H2V66.4Z"
        style={{
          fill: '#f5f5f5',
          fillOpacity: 1,
        }}
      />
      <path
        fill="#F5F5F5"
        d="M0 0h240v263H0z"
        style={{
          fill: '#f5f5f5',
          fillOpacity: 1,
        }}
        transform="translate(2 39)"
      />
      <rect
        width={78}
        height={16}
        x={83}
        y={54}
        fill="#D9D9D9"
        rx={8}
        style={{
          fill: '#d9d9d9',
          fillOpacity: 1,
        }}
      />
      <path
        fill="#2D2D2D"
        d="M36.428 61.321H25.98l6.254-5.428c.1-.088.039-.25-.093-.25h-1.58a.287.287 0 0 0-.188.07l-6.748 5.855a.571.571 0 0 0 0 .862l6.787 5.891a.14.14 0 0 0 .093.036h1.634a.142.142 0 0 0 .093-.25l-6.252-5.429h10.448a.143.143 0 0 0 .143-.143v-1.071a.143.143 0 0 0-.143-.143Z"
        style={{
          fill: '#2d2d2d',
          fillOpacity: 1,
        }}
      />
      <path
        fill="#fff"
        stroke="#4D4D4D"
        d="M22.5 94a7.5 7.5 0 0 1 7.5-7.5h184a7.5 7.5 0 0 1 7.5 7.5v100a7.5 7.5 0 0 1-7.5 7.5H14.46c-1.398 0-2.036-1.742-.969-2.645l6-5.077a8.499 8.499 0 0 0 3.009-6.488V94Z"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          stroke: '#4d4d4d',
          strokeOpacity: 1,
        }}
      />
      <path
        fill="#000"
        d="M31.348 106V95.431h4.035c2.036 0 3.37 1.245 3.37 3.142v.015c0 1.465-.799 2.607-2.125 3.025L39.075 106h-1.546l-2.263-4.182h-2.6V106h-1.318Zm1.318-5.354h2.6c1.355 0 2.124-.725 2.124-2.014v-.015c0-1.26-.82-2.014-2.182-2.014h-2.542v4.043Zm11.323 5.493c-2.256 0-3.618-1.582-3.618-4.057v-.008c0-2.439 1.392-4.109 3.538-4.109s3.45 1.597 3.45 3.955v.498h-5.684c.036 1.634.937 2.586 2.344 2.586 1.069 0 1.728-.505 1.94-.982l.03-.065h1.274l-.014.058c-.272 1.069-1.4 2.124-3.26 2.124Zm-.088-7.038c-1.172 0-2.065.798-2.204 2.299h4.365c-.132-1.56-.996-2.3-2.16-2.3ZM49.336 106v-7.895h1.274v1.2h.117c.352-.849 1.1-1.34 2.132-1.34 1.07 0 1.816.564 2.182 1.385h.118c.425-.835 1.325-1.385 2.417-1.385 1.611 0 2.512.923 2.512 2.578V106h-1.275v-5.164c0-1.164-.534-1.743-1.648-1.743-1.098 0-1.823.828-1.823 1.831V106h-1.275v-5.361c0-.938-.644-1.546-1.64-1.546-1.033 0-1.817.901-1.817 2.014V106h-1.274Zm13.726-9.419a.882.882 0 0 1-.88-.879c0-.483.396-.879.88-.879.483 0 .878.396.878.88a.882.882 0 0 1-.878.878ZM62.416 106v-7.895h1.274V106h-1.274Zm3.677 0v-7.895h1.274v1.186h.117c.396-.835 1.136-1.326 2.3-1.326 1.773 0 2.761 1.048 2.761 2.923V106h-1.274v-4.805c0-1.42-.586-2.102-1.846-2.102-1.26 0-2.058.85-2.058 2.234V106h-1.274Zm11.675.139c-2 0-3.311-1.618-3.311-4.079v-.015c0-2.476 1.304-4.08 3.31-4.08 1.085 0 2.03.542 2.462 1.385h.117v-4.38h1.274V106h-1.274v-1.26h-.117c-.484.879-1.363 1.399-2.461 1.399Zm.292-1.128c1.436 0 2.315-1.128 2.315-2.951v-.015c0-1.824-.879-2.952-2.315-2.952-1.442 0-2.3 1.114-2.3 2.952v.015c0 1.838.858 2.951 2.3 2.951Zm9.229 1.128c-2.256 0-3.618-1.582-3.618-4.057v-.008c0-2.439 1.392-4.109 3.538-4.109s3.45 1.597 3.45 3.955v.498h-5.684c.036 1.634.937 2.586 2.343 2.586 1.07 0 1.729-.505 1.941-.982l.03-.065h1.274l-.015.058c-.27 1.069-1.399 2.124-3.259 2.124Zm-.088-7.038c-1.172 0-2.065.798-2.204 2.299h4.365c-.132-1.56-.996-2.3-2.16-2.3ZM92.637 106v-7.895h1.274v1.171h.117c.3-.827 1.04-1.31 2.11-1.31.241 0 .512.029.637.05v1.238a4.58 4.58 0 0 0-.784-.073c-1.216 0-2.08.77-2.08 1.926V106h-1.274Zm6.753-5.596a.96.96 0 0 1-.953-.952c0-.527.433-.952.953-.952a.95.95 0 0 1 .952.952c0 .52-.425.952-.952.952Zm0 5.669a.96.96 0 0 1-.953-.952c0-.527.433-.952.953-.952a.95.95 0 0 1 .952.952c0 .52-.425.952-.952.952Z"
        opacity={0.9}
        style={{
          fill: '#000',
          fillOpacity: 1,
        }}
      />
      <rect
        width={182}
        height={13}
        x={30}
        y={116}
        fill="#9B9B9B"
        rx={6.5}
        style={{
          fill: '#9b9b9b',
          fillOpacity: 1,
        }}
      />
      <rect
        width={182}
        height={13}
        x={30}
        y={135}
        fill="#9B9B9B"
        rx={6.5}
        style={{
          fill: '#9b9b9b',
          fillOpacity: 1,
        }}
      />
      <rect
        width={182}
        height={13}
        x={30}
        y={154}
        fill="#9B9B9B"
        rx={6.5}
        style={{
          fill: '#9b9b9b',
          fillOpacity: 1,
        }}
      />
      <rect
        width={94}
        height={13}
        x={30}
        y={173}
        fill="#9B9B9B"
        rx={6.5}
        style={{
          fill: '#9b9b9b',
          fillOpacity: 1,
        }}
      />
      <path
        fill="#6CC24A"
        stroke="#000"
        d="m158.686 89.243.002.001a3.15 3.15 0 0 1 1.297 2.479v.008c0 .34-.071.663-.146.947l-.001.003a2359.76 2359.76 0 0 0-1.879 6.98 1.414 1.414 0 0 0-.058.348v.004a.79.79 0 0 0 .227.562.807.807 0 0 0 .562.227h.004c.141 0 .277-.048.494-.175l.004-.003 8.493-4.886.003-.001c.686-.39 1.446-.654 2.302-.654.437 0 .859.064 1.277.193a45.481 45.481 0 0 0 12.518 1.746c21.24 0 38.285-14.3 38.285-31.76 0-17.461-17.059-31.762-38.285-31.762-21.24 0-38.285 14.3-38.285 31.761 0 9.54 5.114 18.137 13.186 23.982Z"
        style={{
          fill: '#6cc24a',
          fillOpacity: 1,
          stroke: '#000',
          strokeOpacity: 1,
        }}
      />
      <path
        fill="#fff"
        d="M170.199 61.332c-.071-.67-.373-1.193-.906-1.566-.527-.374-1.213-.561-2.058-.561-.594 0-1.103.09-1.528.269-.425.179-.75.422-.975.73-.225.306-.34.657-.346 1.051 0 .328.075.612.223.853.154.24.361.445.622.614.261.164.55.302.868.415.317.112.637.207.96.284l1.474.368a10.12 10.12 0 0 1 1.712.56 6.029 6.029 0 0 1 1.482.892c.441.358.789.79 1.045 1.297.256.507.384 1.101.384 1.782 0 .921-.236 1.733-.707 2.434-.471.696-1.152 1.242-2.042 1.636-.886.389-1.958.583-3.218.583-1.223 0-2.286-.189-3.187-.568-.895-.379-1.597-.932-2.104-1.659-.501-.726-.773-1.612-.814-2.656h2.803c.041.547.21 1.003.507 1.366.297.364.684.635 1.16.814.481.18 1.018.27 1.612.27.62 0 1.162-.093 1.628-.277.471-.19.84-.45 1.106-.784.266-.337.402-.732.407-1.182-.005-.41-.126-.748-.361-1.014-.236-.271-.566-.496-.991-.675a9.523 9.523 0 0 0-1.474-.492l-1.789-.46c-1.295-.333-2.319-.838-3.072-1.513-.747-.681-1.121-1.585-1.121-2.711 0-.927.251-1.738.753-2.434.506-.697 1.195-1.237 2.065-1.62.871-.39 1.856-.584 2.957-.584 1.116 0 2.094.194 2.933.583.845.384 1.508.92 1.989 1.605.481.681.729 1.465.745 2.35h-2.742Zm5.497-4.323h3.486l4.669 11.395h.184l4.669-11.395h3.486v15.726h-2.734V61.931h-.146l-4.346 10.758h-2.043l-4.346-10.781h-.146v10.827h-2.733V57.01Zm28.143 4.323c-.072-.67-.374-1.193-.906-1.566-.527-.374-1.213-.561-2.058-.561-.594 0-1.103.09-1.528.269-.425.179-.75.422-.975.73a1.768 1.768 0 0 0-.346 1.051c0 .328.074.612.223.853.153.24.361.445.622.614.261.164.55.302.867.415.318.112.638.207.96.284l1.475.368a10.18 10.18 0 0 1 1.712.56 6.029 6.029 0 0 1 1.482.892c.44.358.788.79 1.044 1.297.256.507.384 1.101.384 1.782 0 .921-.235 1.733-.706 2.434-.471.696-1.152 1.242-2.043 1.636-.885.389-1.958.583-3.217.583-1.224 0-2.286-.189-3.187-.568-.896-.379-1.597-.932-2.104-1.659-.502-.726-.773-1.612-.814-2.656h2.803c.041.547.21 1.003.507 1.366.297.364.683.635 1.159.814.481.18 1.019.27 1.613.27.619 0 1.162-.093 1.628-.277.471-.19.839-.45 1.105-.784.267-.337.402-.732.407-1.182-.005-.41-.125-.748-.36-1.014-.236-.271-.566-.496-.991-.675a9.56 9.56 0 0 0-1.474-.492l-1.79-.46c-1.295-.333-2.319-.838-3.071-1.513-.748-.681-1.121-1.585-1.121-2.711 0-.927.251-1.738.752-2.434.507-.697 1.196-1.237 2.066-1.62.87-.39 1.856-.584 2.956-.584 1.116 0 2.094.194 2.934.583.844.384 1.507.92 1.988 1.605.482.681.73 1.465.745 2.35h-2.741Z"
        style={{
          fill: '#fff',
          fillOpacity: 1,
        }}
      />
      <rect
        width={40}
        height={16}
        x={102}
        y={10}
        fill="#9B9B9B"
        rx={8}
        style={{
          fill: '#9b9b9b',
          fillOpacity: 1,
        }}
      />
    </g>
    <path
      stroke="#E9E9E9"
      strokeWidth={2}
      d="M242 303h1V66.351c0-11.349 0-19.925-.566-26.745-.569-6.841-1.712-12.005-4.05-16.506A41.003 41.003 0 0 0 220.9 5.616c-4.501-2.338-9.665-3.481-16.506-4.05C197.574 1 188.997 1 177.648 1H66.352c-11.35 0-19.926 0-26.746.566-6.841.569-12.005 1.712-16.506 4.05A41 41 0 0 0 5.616 23.1c-2.338 4.501-3.481 9.665-4.05 16.506C1 46.426 1 55.003 1 66.352V303h241Z"
      style={{
        stroke: '#e9e9e9',
        strokeOpacity: 1,
      }}
    />
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M2 66.4c0-22.78 0-34.17 4.503-42.839A40 40 0 0 1 23.561 6.503C32.231 2 43.621 2 66.4 2h111.2c22.78 0 34.169 0 42.839 4.503a40 40 0 0 1 17.058 17.058C242 32.231 242 43.621 242 66.4V302H2V66.4Z"
          style={{
            fill: '#fff',
            fillOpacity: 1,
          }}
        />
      </clipPath>
    </defs>
  </svg>
);

export default DriverOnboardingSmsReminders;
